import { useMemo } from 'react';
import * as R from 'ramda';

import { Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkOrderTask } from '@atom/types/work';
import naturalSort from '@atom/utilities/naturalSortCollator';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import TextOverflowTooltip from '../tooltip/TextOverflowTooltip';

import classes from './workTasks.module.css';

interface Props {
  tasks?: WorkOrderTask[];
  width?: string;
}

const WorkTasks = ({ tasks = [], width = '14rem' }: Props) => {
  if (isNilOrEmpty(tasks)) {
    return <div />;
  }

  const sortedNames = R.sort(
    naturalSort,
    tasks?.map(task => task.name),
  );

  const firstTask = sortedNames[0];

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const additionalTasks = useMemo(() => {
    const additionalNames = R.drop(1, sortedNames);

    return (
      <div>
        {additionalNames.map((name, idx) => (
          <div key={`name_${idx}`}>{name}</div>
        ))}
      </div>
    );
  }, [sortedNames]);

  return (
    <div>
      {tasks?.length === 1 ? (
        <TextOverflowTooltip text={firstTask} width={width} lightTooltip />
      ) : (
        <div className={classes.overflowContainer}>
          <TextOverflowTooltip text={firstTask} width={width} lightTooltip />
          <Tooltip
            lightTooltip
            title={additionalTasks}
            style={{ color: colors.neutral.gray }}
            placement="right"
          >
            <div>{`+${tasks.length - 1}`}</div>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default WorkTasks;
